export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      experience: 'Experience',
      education: 'Education',
      publications: 'Publications',
      contact: 'Contact'
    },
    hero: {
      title: 'Human Rights Expert',
      description: 'Independent human rights expert providing litigation consultancy services before the Turkish Constitutional Court, European Court of Human Rights, and UN treaty bodies.',
      learnMore: 'Learn More About Me',
      getInTouch: 'Get in Touch'
    },
    about: {
      title: 'About Me',
      experience: '10+ Years Experience',
      experienceDesc: 'Turkish judicial service and justice administration',
      international: 'International Expertise',
      internationalDesc: 'European Court of Human Rights assignment',
      academic: 'Academic Excellence',
      academicDesc: 'PhD in Human Rights Law',
      downloadCV: 'Download CV',
      bio: [
        "Dr. Oktay Bahadır is an independent human rights expert specializing in strategic litigation before the European Court of Human Rights and various United Nations mechanisms. His work focuses on complex human rights violations, with a strong background in both international human rights law and criminal law.",
        "Before establishing his independent consultancy practice, he served for more than a decade within the Turkish justice system, including positions in the public prosecution service and in judicial administration. In 2011–2014, he worked as a rapporteur judge at the Turkish Ministry of Justice, where he was responsible for drafting the Government's submissions to the European Court of Human Rights. During this period, he also taught human rights courses at the Turkish Justice Academy.",
        "He previously served as a public prosecutor in several provinces between 2006 and 2016 and completed a two-month professional assignment at the European Court of Human Rights, contributing to the Court's work and deepening his understanding of its procedures and jurisprudence.",
        "Dr. Bahadır holds a master's degree in public law and a PhD in Human Rights Law, completed in 2014. He also pursued one year of English studies in the United States. He has authored numerous academic articles and online publications and is the author of the book The Right to Life.",
        "He is married with three children and is fluent in English and French."
      ]
    },
    experience: {
      title: 'Work Experience',
      positions: [
        { period: '2015 - 2016', position: 'Prosecutor', organization: "Prosecutor's Office of Bafra, Turkey" },
        { period: '2011 - 2015', position: 'Rapporteur Judge', organization: 'The Ministry of Justice, Human Rights Department, Turkey' },
        { period: '2013', position: 'Trainee Judge', organization: 'The European Court of Human Rights, Strasbourg, France' },
        { period: '2012 - 2013', position: 'Lecturer', organization: 'The Justice Academy of Turkey' },
        { period: '2008 - 2011', position: 'Prosecutor', organization: "Prosecutor's Office of Kocaali, Turkey" },
        { period: '2006 - 2008', position: 'Prosecutor', organization: "Prosecutor's Office of Van, Turkey" },
        { period: '2005 - 2006', position: 'Trainee Judge', organization: 'The Ministry of Justice, Turkey' }
      ]
    },
    education: {
      title: 'Education & Certificates',
      diplomas: 'Diplomas',
      certificates: 'Certificates',
      diplomasList: [
        { period: '2009 - 2014', degree: 'PhD', title: 'The Right to Life in the Light of the Case-law of the European Court of Human Rights and Turkey', institution: 'Gazi University, Ankara' },
        { period: '2005 - 2009', degree: "Master's Degree", title: 'The Right to Life in The European Human Rights and The Turkish Constitutional Law', institution: 'Gazi University, Ankara' },
        { period: '1998 - 2003', degree: "Bachelor's Degree", title: 'Law', institution: 'Law Faculty' }
      ],
      certificatesList: [
        { year: '2022', issuer: 'Coursera', title: 'Completion of Introduction to Cybersecurity Tools & Cyber Attacks' },
        { year: '2014', issuer: 'Council of Europe, Steering Committee for Human Rights (CDDH)', title: 'Discussion on the finalization of the draft compilation of existing Council of Europe standards relating to the principles of freedom of thought, conscience and religion and the links to other rights under European Convention on Human Rights (ECHR)' },
        { year: '2013', issuer: 'The Justice Academy of Turkey', title: 'Improving Competence of Lecturers' },
        { year: '2012', issuer: 'The United Nations High Commissioner for Human Rights (OHCHR), Human Rights Committee', title: "First periodic review of the Republic of Turkey's compliance with the International Covenant on Civil and Political Rights (ICCPR)" },
        { year: '2013', issuer: 'Raoul Wallenberg Institute of Human Rights and Humanitarian Law', title: 'Establishing a team of qualified master trainers in the human rights field' },
        { year: '2012', issuer: 'The Justice Academy of Turkey', title: "International Symposium on 'Combating Violence against Women in the Context of Effective Implementation of Human Rights Standards'" },
        { year: '2012', issuer: 'The Justice Academy of Turkey', title: 'Improving Competence of Lecturers' },
        { year: '2011', issuer: 'The Ministry of Justice', title: "High Level Conference and a Workshop on the 'Case-law of the European Court of Human Rights concerning Turkey, Difficulties and Suggestions for Solutions'" },
        { year: '2011', issuer: 'The High Council of Judges and Prosecutors', title: 'Determining the problems of the judicial organisation and draw a roadmap accordingly' }
      ]
    },
    publications: {
      title: 'Publications',
      download: 'Download PDF',
      viewExternal: 'View External Link',
      viewDocument: 'View Document'
    },
    contact: {
      title: 'Get in Touch',
      description: 'For litigation consultancy services or inquiries about human rights matters, please feel free to contact me.',
      name: 'Name',
      namePlaceholder: 'Your full name',
      email: 'Email',
      emailPlaceholder: 'your.email@example.com',
      subject: 'Subject',
      subjectPlaceholder: 'What is this regarding?',
      message: 'Message',
      messagePlaceholder: 'How can I help you?',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message Sent!',
      successDesc: 'Thank you for your message. I will get back to you soon.',
      error: 'Error',
      errorDesc: 'Failed to send message. Please try again or contact directly via email.'
    },
    footer: {
      description: 'Independent human rights expert specializing in international human rights law and litigation consultancy.',
      quickLinks: 'Quick Links',
      connect: 'Connect',
      rights: 'All rights reserved.'
    }
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımda',
      experience: 'Deneyim',
      education: 'Eğitim',
      publications: 'Yayınlar',
      contact: 'İletişim'
    },
    hero: {
      title: 'İnsan Hakları Uzmanı',
      description: 'Türkiye Anayasa Mahkemesi, Avrupa İnsan Hakları Mahkemesi ve çeşitli BM antlaşma organları önünde başvuru sahiplerine dava danışmanlığı hizmeti sunan bağımsız insan hakları uzmanı.',
      learnMore: 'Hakkımda Daha Fazla',
      getInTouch: 'İletişime Geç'
    },
    about: {
      title: 'Hakkımda',
      experience: '10+ Yıl Deneyim',
      experienceDesc: 'Türk yargı hizmeti ve adalet idaresi',
      international: 'Uluslararası Uzmanlık',
      internationalDesc: 'Avrupa İnsan Hakları Mahkemesi görevi',
      academic: 'Akademik Mükemmellik',
      academicDesc: 'İnsan Hakları Hukuku Doktorası',
      downloadCV: 'CV İndir',
      bio: [
        "Dr. Oktay Bahadır, Avrupa İnsan Hakları Mahkemesi ve çeşitli Birleşmiş Milletler mekanizmaları nezdinde stratejik dava takibi konusunda uzmanlaşmış bağımsız bir insan hakları uzmanıdır. Çalışmaları, uluslararası insan hakları hukuku ve ceza hukuku alanlarındaki güçlü akademik ve mesleki altyapısına dayanarak, insan hakları ihlallerine odaklanmaktadır.",
        "Bağımsız danışmanlık faaliyetlerine başlamadan önce, Türk yargı sisteminde on yılı aşkın süre görev yapmış; Cumhuriyet savcılığı ve adalet yönetimi alanlarında çeşitli pozisyonlarda bulunmuştur. 2011–2014 yılları arasında Adalet Bakanlığında tetkik hâkimi olarak görev yapmış ve bu süre boyunca Avrupa İnsan Hakları Mahkemesine sunulan Hükümet görüşlerinin hazırlanmasından sorumlu olmuştur. Aynı dönemde Türkiye Adalet Akademisinde insan hakları dersleri vermiştir.",
        "2006–2016 yılları arasında Türkiye'nin çeşitli illerinde Cumhuriyet savcısı olarak görev yapmış; ayrıca Avrupa İnsan Hakları Mahkemesinde iki aylık mesleki görevlendirme programını tamamlayarak Mahkemenin çalışma usulleri ve içtihadı konusunda birikimini derinleştirmiştir.",
        "Dr. Bahadır, kamu hukuku alanında yüksek lisans derecesine ve 2014 yılında tamamladığı insan hakları hukuku alanında doktora derecesine sahiptir. Bir yıl süreyle Amerika Birleşik Devletleri'nde İngilizce dili eğitimi almış; çok sayıda akademik makale ve çevrimiçi yayın kaleme almış; ayrıca Yaşam Hakkı adlı kitabın yazarıdır.",
        "Evli ve üç çocuk babası olan Dr. Bahadır İngilizce ve Fransızcaya ileri düzeyde hâkimdir."
      ]
    },
    experience: {
      title: 'İş Deneyimi',
      positions: [
        { period: '2015 - 2016', position: 'Savcı', organization: 'Bafra Cumhuriyet Savcılığı, Türkiye' },
        { period: '2011 - 2015', position: 'Raportör Hakim', organization: 'Adalet Bakanlığı, İnsan Hakları Dairesi, Türkiye' },
        { period: '2013', position: 'Stajyer Hakim', organization: 'Avrupa İnsan Hakları Mahkemesi, Strazburg, Fransa' },
        { period: '2012 - 2013', position: 'Öğretim Görevlisi', organization: 'Türkiye Adalet Akademisi' },
        { period: '2008 - 2011', position: 'Savcı', organization: 'Kocaali Cumhuriyet Savcılığı, Türkiye' },
        { period: '2006 - 2008', position: 'Savcı', organization: 'Van Cumhuriyet Savcılığı, Türkiye' },
        { period: '2005 - 2006', position: 'Stajyer Hakim', organization: 'Adalet Bakanlığı, Türkiye' }
      ]
    },
    education: {
      title: 'Eğitim ve Sertifikalar',
      diplomas: 'Diplomalar',
      certificates: 'Sertifikalar',
      diplomasList: [
        { period: '2009 - 2014', degree: 'Doktora', title: 'Avrupa İnsan Hakları Mahkemesi İçtihatları Işığında Yaşama Hakkı ve Türkiye', institution: 'Gazi Üniversitesi, Ankara' },
        { period: '2005 - 2009', degree: 'Yüksek Lisans', title: 'Avrupa İnsan Hakları ve Türk Anayasa Hukukunda Yaşama Hakkı', institution: 'Gazi Üniversitesi, Ankara' },
        { period: '1998 - 2003', degree: 'Lisans', title: 'Hukuk', institution: 'Hukuk Fakültesi' }
      ],
      certificatesList: [
        { year: '2022', issuer: 'Coursera', title: 'Siber Güvenlik Araçları ve Siber Saldırılara Giriş Sertifikası' },
        { year: '2014', issuer: 'Avrupa Konseyi, İnsan Hakları Yönlendirme Komitesi (CDDH)', title: 'Düşünce, vicdan ve din özgürlüğü ilkeleriyle ilgili mevcut Avrupa Konseyi standartlarının taslak derlemesinin sonuçlandırılması üzerine tartışma' },
        { year: '2013', issuer: 'Türkiye Adalet Akademisi', title: 'Öğretim Görevlilerinin Yetkinliğini Geliştirme' },
        { year: '2012', issuer: 'Birleşmiş Milletler İnsan Hakları Yüksek Komiserliği (OHCHR), İnsan Hakları Komitesi', title: "Türkiye Cumhuriyeti'nin Medeni ve Siyasi Haklara İlişkin Uluslararası Sözleşmeye uyumunun ilk periyodik incelemesi" },
        { year: '2013', issuer: 'Raoul Wallenberg İnsan Hakları ve İnsani Hukuk Enstitüsü', title: 'İnsan hakları alanında kalifiye ana eğitmenler ekibi oluşturulması' },
        { year: '2012', issuer: 'Türkiye Adalet Akademisi', title: 'İnsan Hakları Standartlarının Etkin Uygulaması Bağlamında Kadına Yönelik Şiddete Karşı Mücadele Uluslararası Sempozyumu' },
        { year: '2012', issuer: 'Türkiye Adalet Akademisi', title: 'Öğretim Görevlilerinin Yetkinliğini Geliştirme' },
        { year: '2011', issuer: 'Adalet Bakanlığı', title: 'Türkiye ile ilgili Avrupa İnsan Hakları Mahkemesi İçtihatları, Zorluklar ve Çözüm Önerileri konulu Yüksek Düzeyli Konferans ve Çalıştay' },
        { year: '2011', issuer: 'Hakimler ve Savcılar Yüksek Kurulu', title: 'Yargı teşkilatının sorunlarının belirlenmesi ve buna göre bir yol haritası çizilmesi' }
      ]
    },
    publications: {
      title: 'Yayınlar',
      download: 'PDF İndir',
      viewExternal: 'Harici Linki Görüntüle',
      viewDocument: 'Belgeyi Görüntüle'
    },
    contact: {
      title: 'İletişime Geçin',
      description: 'Dava danışmanlığı hizmetleri veya insan hakları konuları hakkında sorularınız için lütfen benimle iletişime geçmekten çekinmeyin.',
      name: 'İsim',
      namePlaceholder: 'Adınız ve soyadınız',
      email: 'E-posta',
      emailPlaceholder: 'email@example.com',
      subject: 'Konu',
      subjectPlaceholder: 'Bu ne hakkında?',
      message: 'Mesaj',
      messagePlaceholder: 'Size nasıl yardımcı olabilirim?',
      send: 'Mesaj Gönder',
      sending: 'Gönderiliyor...',
      success: 'Mesaj Gönderildi!',
      successDesc: 'Mesajınız için teşekkür ederim. En kısa sürede size dönüş yapacağım.',
      error: 'Hata',
      errorDesc: 'Mesaj gönderilemedi. Lütfen tekrar deneyin veya doğrudan e-posta ile iletişime geçin.'
    },
    footer: {
      description: 'Uluslararası insan hakları hukuku ve dava danışmanlığı konusunda uzmanlaşmış bağımsız insan hakları uzmanı.',
      quickLinks: 'Hızlı Linkler',
      connect: 'Bağlantı',
      rights: 'Tüm hakları saklıdır.'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      experience: 'Expérience',
      education: 'Formation',
      publications: 'Publications',
      contact: 'Contact'
    },
    hero: {
      title: 'Expert en Droits de l\'Homme',
      description: 'Expert indépendant en droits de l\'homme fournissant des services de conseil en contentieux devant la Cour constitutionnelle turque, la Cour européenne des droits de l\'homme et les organes de traités des Nations Unies.',
      learnMore: 'En savoir plus',
      getInTouch: 'Me contacter'
    },
    about: {
      title: 'À propos de moi',
      experience: '10+ Ans d\'Expérience',
      experienceDesc: 'Service judiciaire turc et administration de la justice',
      international: 'Expertise Internationale',
      internationalDesc: 'Affectation à la Cour européenne des droits de l\'homme',
      academic: 'Excellence Académique',
      academicDesc: 'Doctorat en droit des droits de l\'homme',
      downloadCV: 'Télécharger CV',
      bio: [
        "Dr. Oktay Bahadır est un expert indépendant en droits de l'homme spécialisé dans les litiges stratégiques devant la Cour européenne des droits de l'homme et divers mécanismes des Nations Unies. Son travail se concentre sur les violations complexes des droits de l'homme, avec une solide formation en droit international des droits de l'homme et en droit pénal.",
        "Avant d'établir sa pratique de conseil indépendante, il a servi pendant plus d'une décennie au sein du système judiciaire turc, y compris des postes dans le service du ministère public et dans l'administration judiciaire. De 2011 à 2014, il a travaillé comme juge rapporteur au ministère turc de la Justice, où il était responsable de la rédaction des observations du gouvernement à la Cour européenne des droits de l'homme. Durant cette période, il a également enseigné des cours sur les droits de l'homme à l'Académie de justice turque.",
        "Il a précédemment servi comme procureur public dans plusieurs provinces entre 2006 et 2016 et a effectué une mission professionnelle de deux mois à la Cour européenne des droits de l'homme, contribuant aux travaux de la Cour et approfondissant sa compréhension de ses procédures et de sa jurisprudence.",
        "Dr. Bahadır est titulaire d'un master en droit public et d'un doctorat en droit des droits de l'homme, obtenu en 2014. Il a également poursuivi une année d'études d'anglais aux États-Unis. Il est l'auteur de nombreux articles académiques et publications en ligne et est l'auteur du livre Le Droit à la Vie.",
        "Il est marié avec trois enfants et parle couramment l'anglais et le français."
      ]
    },
    experience: {
      title: 'Expérience Professionnelle',
      positions: [
        { period: '2015 - 2016', position: 'Procureur', organization: "Parquet de Bafra, Turquie" },
        { period: '2011 - 2015', position: 'Juge Rapporteur', organization: 'Ministère de la Justice, Département des Droits de l\'Homme, Turquie' },
        { period: '2013', position: 'Juge Stagiaire', organization: 'Cour européenne des droits de l\'homme, Strasbourg, France' },
        { period: '2012 - 2013', position: 'Chargé de cours', organization: 'Académie de Justice de Turquie' },
        { period: '2008 - 2011', position: 'Procureur', organization: "Parquet de Kocaali, Turquie" },
        { period: '2006 - 2008', position: 'Procureur', organization: "Parquet de Van, Turquie" },
        { period: '2005 - 2006', position: 'Juge Stagiaire', organization: 'Ministère de la Justice, Turquie' }
      ]
    },
    education: {
      title: 'Formation et Certificats',
      diplomas: 'Diplômes',
      certificates: 'Certificats',
      diplomasList: [
        { period: '2009 - 2014', degree: 'Doctorat', title: 'Le droit à la vie à la lumière de la jurisprudence de la CEDH et de la Turquie', institution: 'Université Gazi, Ankara' },
        { period: '2005 - 2009', degree: 'Master', title: 'Le droit à la vie dans les droits de l\'homme européens et le droit constitutionnel turc', institution: 'Université Gazi, Ankara' },
        { period: '1998 - 2003', degree: 'Licence', title: 'Droit', institution: 'Faculté de Droit' }
      ],
      certificatesList: [
        { year: '2022', issuer: 'Coursera', title: 'Introduction aux outils de cybersécurité et aux cyberattaques' },
        { year: '2014', issuer: 'Conseil de l\'Europe, CDDH', title: 'Discussion sur la finalisation du projet de compilation des normes du Conseil de l\'Europe' },
        { year: '2013', issuer: 'Académie de Justice de Turquie', title: 'Amélioration des compétences des enseignants' },
        { year: '2012', issuer: 'OHCHR, Comité des droits de l\'homme', title: 'Premier examen périodique de la conformité de la Turquie au PIDCP' }
      ]
    },
    publications: {
      title: 'Publications',
      download: 'Télécharger PDF',
      viewExternal: 'Voir le lien externe',
      viewDocument: 'Voir le document'
    },
    contact: {
      title: 'Me Contacter',
      description: 'Pour des services de conseil en contentieux ou des questions sur les droits de l\'homme, n\'hésitez pas à me contacter.',
      name: 'Nom',
      namePlaceholder: 'Votre nom complet',
      email: 'E-mail',
      emailPlaceholder: 'votre.email@example.com',
      subject: 'Sujet',
      subjectPlaceholder: 'De quoi s\'agit-il?',
      message: 'Message',
      messagePlaceholder: 'Comment puis-je vous aider?',
      send: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Message Envoyé!',
      successDesc: 'Merci pour votre message. Je vous répondrai bientôt.',
      error: 'Erreur',
      errorDesc: 'Échec de l\'envoi du message. Veuillez réessayer ou me contacter directement par e-mail.'
    },
    footer: {
      description: 'Expert indépendant en droits de l\'homme spécialisé dans le droit international des droits de l\'homme et le conseil en contentieux.',
      quickLinks: 'Liens Rapides',
      connect: 'Connexion',
      rights: 'Tous droits réservés.'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über mich',
      experience: 'Erfahrung',
      education: 'Bildung',
      publications: 'Publikationen',
      contact: 'Kontakt'
    },
    hero: {
      title: 'Menschenrechtsexperte',
      description: 'Unabhängiger Menschenrechtsexperte, der Prozessberatungsdienste vor dem türkischen Verfassungsgericht, dem Europäischen Gerichtshof für Menschenrechte und UN-Vertragsorganen anbietet.',
      learnMore: 'Mehr erfahren',
      getInTouch: 'Kontakt aufnehmen'
    },
    about: {
      title: 'Über mich',
      experience: '10+ Jahre Erfahrung',
      experienceDesc: 'Türkischer Justizdienst und Justizverwaltung',
      international: 'Internationale Expertise',
      internationalDesc: 'Tätigkeit am Europäischen Gerichtshof für Menschenrechte',
      academic: 'Akademische Exzellenz',
      academicDesc: 'Promotion in Menschenrechtsrecht',
      downloadCV: 'Lebenslauf herunterladen',
      bio: [
        "Dr. Oktay Bahadır ist ein unabhängiger Menschenrechtsexperte, der sich auf strategische Prozessführung vor dem Europäischen Gerichtshof für Menschenrechte und verschiedenen Mechanismen der Vereinten Nationen spezialisiert hat. Seine Arbeit konzentriert sich auf komplexe Menschenrechtsverletzungen, mit einem starken Hintergrund sowohl im internationalen Menschenrechtsrecht als auch im Strafrecht.",
        "Bevor er seine unabhängige Beratungspraxis gründete, war er mehr als ein Jahrzehnt im türkischen Justizsystem tätig, einschließlich Positionen im Staatsanwaltschaftsdienst und in der Justizverwaltung. Von 2011 bis 2014 arbeitete er als Berichterstatterrichter im türkischen Justizministerium, wo er für die Ausarbeitung der Stellungnahmen der Regierung an den Europäischen Gerichtshof für Menschenrechte verantwortlich war. In dieser Zeit unterrichtete er auch Menschenrechtskurse an der türkischen Justizakademie.",
        "Er war zuvor zwischen 2006 und 2016 als Staatsanwalt in mehreren Provinzen tätig und absolvierte einen zweimonatigen beruflichen Einsatz am Europäischen Gerichtshof für Menschenrechte, wobei er zur Arbeit des Gerichts beitrug und sein Verständnis seiner Verfahren und Rechtsprechung vertiefte.",
        "Dr. Bahadır hat einen Masterabschluss in öffentlichem Recht und eine Promotion in Menschenrechtsrecht, die er 2014 abschloss. Er absolvierte auch ein Jahr Englischstudium in den Vereinigten Staaten. Er hat zahlreiche akademische Artikel und Online-Publikationen verfasst und ist Autor des Buches Das Recht auf Leben.",
        "Er ist verheiratet, hat drei Kinder und spricht fließend Englisch und Französisch."
      ]
    },
    experience: {
      title: 'Berufserfahrung',
      positions: [
        { period: '2015 - 2016', position: 'Staatsanwalt', organization: 'Staatsanwaltschaft Bafra, Türkei' },
        { period: '2011 - 2015', position: 'Berichterstatterrichter', organization: 'Justizministerium, Abteilung für Menschenrechte, Türkei' },
        { period: '2013', position: 'Praktikantenrichter', organization: 'Europäischer Gerichtshof für Menschenrechte, Straßburg, Frankreich' },
        { period: '2012 - 2013', position: 'Dozent', organization: 'Justizakademie der Türkei' },
        { period: '2008 - 2011', position: 'Staatsanwalt', organization: 'Staatsanwaltschaft Kocaali, Türkei' },
        { period: '2006 - 2008', position: 'Staatsanwalt', organization: 'Staatsanwaltschaft Van, Türkei' },
        { period: '2005 - 2006', position: 'Praktikantenrichter', organization: 'Justizministerium, Türkei' }
      ]
    },
    education: {
      title: 'Bildung und Zertifikate',
      diplomas: 'Diplome',
      certificates: 'Zertifikate',
      diplomasList: [
        { period: '2009 - 2014', degree: 'Promotion', title: 'Das Recht auf Leben im Lichte der Rechtsprechung des EGMR und der Türkei', institution: 'Gazi Universität, Ankara' },
        { period: '2005 - 2009', degree: 'Master', title: 'Das Recht auf Leben in den europäischen Menschenrechten und dem türkischen Verfassungsrecht', institution: 'Gazi Universität, Ankara' },
        { period: '1998 - 2003', degree: 'Bachelor', title: 'Rechtswissenschaften', institution: 'Rechtswissenschaftliche Fakultät' }
      ],
      certificatesList: [
        { year: '2022', issuer: 'Coursera', title: 'Einführung in Cybersicherheitstools und Cyberangriffe' },
        { year: '2014', issuer: 'Europarat, CDDH', title: 'Diskussion zur Fertigstellung des Entwurfs einer Zusammenstellung bestehender Europarats-Standards' },
        { year: '2013', issuer: 'Justizakademie der Türkei', title: 'Verbesserung der Kompetenz von Dozenten' },
        { year: '2012', issuer: 'OHCHR, Menschenrechtsausschuss', title: 'Erste periodische Überprüfung der Einhaltung des IPBPR durch die Türkei' }
      ]
    },
    publications: {
      title: 'Publikationen',
      download: 'PDF herunterladen',
      viewExternal: 'Externen Link anzeigen',
      viewDocument: 'Dokument anzeigen'
    },
    contact: {
      title: 'Kontakt aufnehmen',
      description: 'Für Prozessberatungsdienste oder Anfragen zu Menschenrechtsfragen können Sie mich gerne kontaktieren.',
      name: 'Name',
      namePlaceholder: 'Ihr vollständiger Name',
      email: 'E-Mail',
      emailPlaceholder: 'ihre.email@example.com',
      subject: 'Betreff',
      subjectPlaceholder: 'Worum geht es?',
      message: 'Nachricht',
      messagePlaceholder: 'Wie kann ich Ihnen helfen?',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      success: 'Nachricht gesendet!',
      successDesc: 'Vielen Dank für Ihre Nachricht. Ich werde mich bald bei Ihnen melden.',
      error: 'Fehler',
      errorDesc: 'Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder kontaktieren Sie mich direkt per E-Mail.'
    },
    footer: {
      description: 'Unabhängiger Menschenrechtsexperte, spezialisiert auf internationales Menschenrechtsrecht und Prozessberatung.',
      quickLinks: 'Schnelllinks',
      connect: 'Verbinden',
      rights: 'Alle Rechte vorbehalten.'
    }
  }
};

export const languageNames = {
  en: 'English',
  tr: 'Türkçe',
  fr: 'Français',
  de: 'Deutsch'
};
